<template>

  <section class="plate nameplate">
    <header class="plate-header">
      <div class="plate-header-img">
        <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${report.img}.png`">
      </div>
      <h2>{{statePlate.name}}</h2>
      <h4>Report: {{statePlate.dateRange}}</h4>
    </header>
    <div class="plate-body nameplate-body">
      <div class="plate-body-sec">
        <img class="nameplate-flag" :src="`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${statePlate.country}.svg`" :alt="report.entity.country">
      </div>
      <div v-for="(prop, propIndex) in orgProperties()" class="plate-body-sec">
        <h5>{{statePlate[prop]}}</h5>
        <!-- <h5 v-if="Array.isArray(report.entity[prop])">{{`${report.entity[prop].length} ${prop[0].toUpperCase() + prop.substring(1, prop.length)}${report.entity[prop].length == 1 ? '' : 's'}`}}</h5>
        <h5 v-else>{{report.entity[prop]}}</h5> -->
      </div>
    </div>
  </section>

</template>

<script>

import moment from 'moment';

export default {
  data(){
    return {
    }
  },
  props: ['report'],
  computed: {
    statePlate: function(){
      return this.$store.getters.getStatePlate();
    }
  },
  methods: {
    orgProperties(){
      return [
        'city',
        'state',
        'street',
        'zipCode',
        'buildings'
      ]
    },
    dateRange(){
      function momentify(tms){
        return moment(tms * 1000).format('MM/DD')
      }
      return `${momentify(this.report.reports[0].tms)} ~ ${momentify(this.report.reports[this.report.reports.length - 1].tms)}`
    }
  },
  mounted(){
    console.log({STATE_PLATE: this.statePlate});
  }
}

</script>

<style>

.nameplate {
  width: 25%;
}

.nameplate-flag {
  width: 50px;
}

.plate-header h4 {
  width: 30%;
  margin-right: 4%;
  text-align: center;
  color: rgb(0, 153, 191);
}

</style>



// WEBPACK FOOTER //
// src/components/report/Nameplate.vue